import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import {
  LIFECYCLE_WATCH_SUBSTATUS_COLORS,
  LIFECYCLE_WATCH_SUBSTATUS_LABELS,
  type LifecycleWatchSubstatus,
} from '@/constants/lifecycleStages';

interface Props {
  value: LifecycleWatchSubstatus | null | undefined;
  className?: string;
}

export default function WatchSubstatusBadge({ value, className }: Props) {
  // Watch substatus design: null = default "Đang theo dõi" (no "Chưa set" state)
  const effective: LifecycleWatchSubstatus = value ?? 'theo_doi';
  return (
    <Badge
      variant="outline"
      className={cn(
        'inline-flex items-center gap-1 text-[10px] px-2 py-0.5 font-semibold rounded-md border',
        LIFECYCLE_WATCH_SUBSTATUS_COLORS[effective],
        className,
      )}
    >
      {LIFECYCLE_WATCH_SUBSTATUS_LABELS[effective]}
    </Badge>
  );
}
